<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row justify="center">
            <v-col cols="12" md="12" lg="8">
                <v-container>
                    <h2>{{ $t('login.title') }}</h2>
                    <label>{{ $t('global.form.usernameOrEmail') }}</label>
                    <v-text-field v-model="username" :placeholder="$t('global.form.usernameOrEmail')"
                        variant="outlined" hide-details="true" density="compact" class="py-0 mb-3" height="32px">
                    </v-text-field>
                    <label> {{ $t('login.form.password') }}</label>

                    <v-text-field v-model="password" :type="show1 ? 'password' : 'text'" placeholder="Passwort"
                        variant="outlined" hide-details="true" density="compact" class="py-0" height="32px">
                        <template v-slot:append-inner>
                            <v-btn @click.stop="show1 = !show1" variant="flat" class="border" rounded="0"
                                color="default" :ripple="false" :focus="false"> <v-icon color="black">{{ show1 ?
                                    'mdi-eye' : 'mdi-eye-off' }}</v-icon></v-btn>
                        </template>
                    </v-text-field>
                    <v-btn variant="text" :ripple="false" elevation="0" @click="$router.push({ name: 'PasswordForgot' })" >{{ $t('login.form.passwordforgot') }}</v-btn >
                    <v-row justify="between">
                        <v-col cols="12" sm="9">
                            <v-checkbox size="x-small" class="w-100" v-model="checked" :error-messages="errorHint">
                                <template v-slot:label>
                                    <div v-html="$t('login.messages.tac.accept.findeling')">

                                    </div>
                                </template>
                            </v-checkbox>
                        </v-col>
                        <v-col>
                            <v-btn @click="login" variant="flat" size="large" color="primary" rounded="xl"
                                class="white--text mb-2 find-favourites-button">{{ $t('login.form.button') }}</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { ref, getCurrentInstance, inject } from "vue";
import { useRouter } from 'vue-router'

export default {
    data() {
        return {
            tab: 'Lieblingsmarken',
        }
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const password = ref(null);
        const username = ref(null);
        const router = useRouter();
        const fetchOwnShop = inject('fetchOwnShop');
        const fetchMe = inject('fetchMe');
        const checked = ref(false);
        const errorHint = ref(null);
        const show1 = ref(true)

        const login = async () => {
            if (!checked.value) {
                errorHint.value = 'Bitte akzeptiere unsere AGB'
                return
            }
            try {
                const response = await proxy.$axios.post("/public/login", {
                    password: password.value,
                    username: username.value,
                });
                if (response.data.status == "OK") {
                    if (response.data.data.roles.includes("DEALER")){
                        successfullyLoggenIn(response.data);
                    }else if(response.data.data.roles.length === 1 && response.data.data.roles.includes("USER")){
                        refuseLogin()
                    }
                }
            } catch (error) {
                console.error("Error: ", error);
                proxy.$toast.error(proxy.$t('login.messages.error.invalid_login'), { theme: "colored" });
            }
        };
        const openDownloadAppHint = inject('openDownloadAppHint')
        const refuseLogin =() =>{
            openDownloadAppHint();
            proxy.$toast.error(proxy.$t('login.messages.error.no_shopowner'), { theme: "colored" });
        }

        const successfullyLoggenIn = (data) => {
            const { hardToken, softToken } = data.data;
            if (hardToken && softToken) {
                // Store the tokens securely
                localStorage.setItem("hardToken", hardToken); // Persistent storage
                localStorage.setItem("softToken", softToken); // Session storage
                localStorage.setItem('username', data.data.username)
                proxy.$user.value = data;
                console.log("Tokens stored successfully.");
                fetchOwnShop();
                fetchMe();
                console.log(data.data.roles)
                if (data.data.roles.includes('BACKOFFICE')) {
                    router.push({ name: "backoffice.shops" });
                } else if (data.data.roles.includes('DEALER')) {
                    router.push({ name: "shopHome" });
                }
                // Redirect to dashboard or another page
                // window.location.replace('/shop/home');
            } else {
                console.error("Missing tokens in response:", data);
            }
            // window.location.reload();
        };

        return {
            show1,
            login,
            password,
            username,
            checked,
            errorHint
        };
    },
};
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    width: 900px;
}

.v-tab-selected {
    text-decoration: underline;
}

.v-tab {
    font-size: 26px;
    font-weight: 800;
    font-family: Montserrat, sans-serif;
    letter-spacing: normal;
}

.v-btn.find-favourites-button {
    font-size: 14px;
    font-weight: 400;
    float: right;
}

a {
    text-decoration: none;
    font-size: 14px;
    font-weight: 300;
}

.v-label div {
    display: inline-block;
    max-width: 100%;
    /* margin-bottom: 5px; */
    font-weight: 700;
    font-size: 14px;
}
</style>